import { FileDown, FileText } from "lucide-react";

const BASE = process.env.REACT_APP_BACKEND_URL;
const PDFS = [
  { key: "industry", title: "Industry Guides", pages: "13 pages",
    desc: "Tailored for Construction, Realty Groups, Lawyers' Offices and Doctors' Offices." },
  { key: "site", title: "How Elevare Works", pages: "6 pages",
    desc: "The Elevare Cycle, services, who we help, the Client Portal and engagement levels." },
  { key: "overview", title: "Company Overview", pages: "9 pages",
    desc: "Three design variations of the company overview to pick from." },
  { key: "tools", title: "Tools Overview", pages: "12 pages",
    desc: "Getting Started, Expense AI Vault, the Client Portal and CRM — three styles." },
];

export default function OverviewDownloads() {
  return (
    <div data-testid="overview-downloads" className="rounded-2xl border border-[#1e3d3a]/12 bg-white p-5 lg:p-6">
      <div className="flex items-center gap-2 text-[#1e3d3a] mb-1">
        <FileDown className="h-4 w-4 text-[#c9a961]" />
        <h3 className="font-head text-lg">Sales &amp; overview PDFs</h3>
      </div>
      <p className="text-sm text-[#1e3d3a]/55 mb-4">One-click downloads of your client-facing guides — no links to paste.</p>
      <div className="grid sm:grid-cols-2 gap-3">
        {PDFS.map((p) => (
          <div key={p.key} data-testid={`overview-dl-card-${p.key}`} className="flex items-start justify-between gap-3 rounded-xl border border-[#1e3d3a]/10 bg-[#f4f1e9] px-4 py-3">
            <div className="min-w-0">
              <div className="flex items-center gap-2">
                <FileText className="h-4 w-4 text-[#a3823f] shrink-0" />
                <span className="font-head text-base text-[#1e3d3a]">{p.title}</span>
                <span className="text-[10px] uppercase tracking-wide text-[#1e3d3a]/40">{p.pages}</span>
              </div>
              <p className="mt-1 text-xs text-[#1e3d3a]/55">{p.desc}</p>
            </div>
            <a
              data-testid={`overview-dl-${p.key}`}
              href={`${BASE}/api/overview-pdf/${p.key}`}
              className="shrink-0 inline-flex items-center gap-1.5 rounded-full bg-[#1e3d3a] px-3.5 py-2 text-xs font-semibold text-white hover:bg-[#2a534d] transition-colors"
            >
              <FileDown className="h-3.5 w-3.5" /> Download
            </a>
          </div>
        ))}
      </div>
    </div>
  );
}
